import React, { useRef } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import styles from './Map.module.css';
import PositionIcon from '../../assets/icons/Vector.svg';

/**
 * Zoom buttons component
 * Provides zoom in/out controls for the map
 */
export function ZoomButtons() {
  const map = useMap();

  return (
    <div className={styles.zoomButtons}>
      <button
        onClick={() => map.zoomIn()}
        title="Zoom in"
        className={styles.zoomButton}
      >
        +
      </button>
      <button
        onClick={() => map.zoomOut()}
        title="Zoom out"
        className={styles.zoomButton}
      >
        -
      </button>
    </div>
  );
}

/**
 * Current location button component
 * Flies to user's current location when clicked
 */
export function CurrentLocationButton() {
  const map = useMap();
  const markerRef = useRef(null);

  const handleClick = () => {
    if (!navigator.geolocation) {
      alert("Geolocalizzazione non supportata");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        map.flyTo([latitude, longitude], 18);

        // Remove existing marker
        if (markerRef.current) {
          map.removeLayer(markerRef.current);
        }

        // Create new marker
        const icon = L.icon({
          iconUrl: require("leaflet/dist/images/marker-icon.png"),
          iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
          shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
          iconSize: [25, 41],
          iconAnchor: [12, 41],
          popupAnchor: [1, -34],
          shadowSize: [41, 41],
        });

        const newMarker = L.marker([latitude, longitude], { icon })
          .addTo(map)
          .bindPopup("Sei qui")
          .openPopup();

        markerRef.current = newMarker;
      },
      (error) => {
        console.error("Error getting location:", error);
        alert("Impossibile ottenere la tua posizione.");
      }
    );
  };

  return (
    <button
      onClick={handleClick}
      title="Vai alla mia posizione"
      className={styles.currentLocationButton}
    >
      <img src={PositionIcon} alt="Current location" />
    </button>
  );
}

/**
 * Map controls wrapper component
 * Combines zoom and location controls
 */
export default function MapControls() {
  return (
    <div className={styles.mapControls}>
      <CurrentLocationButton />
      <ZoomButtons />
    </div>
  );
}
